module.exports = "<form class=\"f-nav-main-search form-inline mt-md-0 2 menuform\" [formGroup]=\"form\" (submit)=\"onSubmit(form.value)\" (keyup)=\"onKey(form.value)\">\n  <input class=\"f-nav-main-search__search form-control\" type=\"text\" placeholder=\"Search\" formControlName=\"search\">\n  <button class=\"f-nav-main-search__action\" type=\"submit\">\n    <i class=\"fa fa-search\" aria-hidden=\"true\"></i>\n  </button>\n</form>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/components/nav/search-form/search-form.html
// module id = ./src/app/main/components/nav/search-form/search-form.html
// module chunks = main